<template>
  <div class="login-module">
    <div class="login-tab">
      <div class="close-btn" @click="close">
        <span class="iconfont icon-a-CombinedShape4" style="font-size: 12px;"></span>
      </div>
      <p class="login-textc">忘记密码</p>
      <p class="login-texte">FORGET  PASSWORD</p>
      <el-form :model="editForm" label-width="100px" ref="editForm">
        <div class="login-input">
          <div class="phoneinput">
            <div class="phone">
              <img src="../../assets/images/shouji.png" alt />
            </div>
            <div class="c-input">
              <el-form-item type="primary">
                <el-input
                  oninput="value=value.replace(/\D/g, '')"
                  maxlength="11"
                  placeholder="请输入手机号码"
                  @input="disabledcodeClick"
                  @blur="verifyBlur"
                  v-model="editForm.username"
                ></el-input>
              </el-form-item>
              <div class="errorhint" v-show="errorhint">{{errorhinttext}}</div>
            </div>
          </div>

          <div class="phoneinput">
            <div class="phone">
              <img src="../../assets/images/wangji.png" alt />
            </div>
            <div class="b-input">
              <div class="codeinput">
                <el-form-item type="primary">
                  <el-input
                    placeholder="请输入验证码"
                    @input="disabledcodeClick"
                    maxlength="4"
                    v-model="editForm.code"
                  ></el-input>
                </el-form-item>
                <div class="errorhint" v-show="errorhintCode">{{errorhinttextCode}}</div>
              </div>

              <div class="codebtn">
                <el-button
                  type="primary"
                  :class="[disabled==false?'el-button--primary':'el-button--primaryno']"
                  :disabled="disabled"
                  @click="verification"
                >{{btntxt}}</el-button>
              </div>
            </div>
          </div>

          <!-- <div class="forget">
          <p>忘记密码</p>
          </div>-->

          <div class="register">
            <el-button
              type="primary"
              :class="[nextdisabled==false?'el-button--primary':'el-button--primaryno']"
              :disabled="nextdisabled"
              @click.native.prevent="nextstepClick"
            >下一步</el-button>
          </div>
          <div class="right-bottom">
            <span @click="handleTab">账号登录 ></span>
          </div>
        </div>
      </el-form>
      <transition name="plus-icon">
        <HintPrompt :markedwords="markedwords" v-show="hintpromptstate" />
      </transition>
    </div>
    <!-- 背景 -->
    <!-- <div class="login-back">
      <div class="back-text">
        <h2>在线直播</h2>
        <p class="po">便携录播系统具有一键推送全网直播功能</p>
        <p class="pt">支持触摸操作，可显示多路预览画面以及主播画面，可控制摄像头转动与变焦</p>
        <div class="register-zc" @click="registerClick">登录</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import HintPrompt from "@/components/wx-hintprompt";
import { ForgetPasswordCode, ForgetPassCode, isUse } from "@/api/login";
export default {
  components: { HintPrompt },
  props: {
    loginparameters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      timeout: null,
      timeouta: null,
      hintpromptstate: false, //提示框状态
      markedwords: "", //提示框文字
      errorhint: false,
      errorhinttext: "",
      errorhintCode: false,
      errorhinttextCode: "",
      editForm: {
        username: "",
        code: "",
      },
      nextdisabled: true, //下一步颜色
      disabled: true, //灰色
      time: 0, //验证码时间

      btntxt: "获取验证码",
      logindata: this.loginparameters,
    };
  },
  computed: {},
  methods: {
    //失去焦点验证手机格式
    verifyBlur() {
      let phoneInt = /^1[3456789]\d{9}$/;
      if (this.editForm.username == "") {
        this.errorhint = true;
        this.errorhinttext = "请输入手机号码";
      } else if (phoneInt.test(this.editForm.username) == false) {
        this.errorhint = true;
        this.errorhinttext = "手机号码格式不正确";
      } else {
        this.errorhint = false;
      }
    },
    //手机号 验证码输入判断
    disabledcodeClick() {
      //下一步按钮判断
      if (this.editForm.code != "" && this.editForm.username != "") {
        this.nextdisabled = false;
      } else {
        this.nextdisabled = true;
      }
      let phoneInt = /^1[3456789]\d{9}$/;
      let captcha = /^\d{4}$/;
      //验证码按钮判断
      if (this.editForm.username != "") {
        this.errorhint = false;
        if (this.time == 0) {
          this.disabled = false;
        }
      } else {
        this.disabled = true;
        this.errorhint = false;
      }
    },
    nextstepClick() {
      //验证注册账号
      let phoneInt = /^1[3456789]\d{9}$/;
      let captcha = /^\d{4}$/;
      if (this.editForm.username == "") {
        this.errorhint = true;
        this.errorhinttext = "请输入手机号码";
      } else if (phoneInt.test(this.editForm.username) == false) {
        this.errorhint = true;
        this.errorhinttext = "手机号码格式不正确";
      } else if (this.editForm.code == "") {
        this.errorhintCode = true;
        this.errorhinttextCode = "请输入验证码";
      } else if (captcha.test(this.editForm.code) == false) {
        this.errorhintCode = true;
        this.errorhinttextCode = "验证码格式错误";
      } else {
        this.errorhintCode = false;
        this.errorhint = false;

        ForgetPasswordCode(this.editForm).then((res) => {
          if (res.code === 200) {
            this.logindata.settingUsername = this.editForm.username;
            this.logindata.settingCode = this.editForm.code;
            this.logindata.settingdata = true;
            this.editForm.username = "";
            this.editForm.code = "";
            this.disabled = true; //验证码颜色
            this.nextdisabled = true; //下一步颜色
          } else if (res.code === 3000) {
            this.errorhintCode = true;
            this.errorhinttextCode = "验证码错误";
          }
        });
      }
    },

    registerClick() {
      this.logindata.logindata = true;
      this.logindata.forgetdata = false;
      this.logindata.settingdata = false;
    },

    verification() {
      let phoneInt = /^1[3456789]\d{9}$/;
      let captcha = /^\d{4}$/;
      if (phoneInt.test(this.editForm.username) == false) {
        this.errorhint = true;
        this.errorhinttext = "手机号码格式不正确";
        return false
      }
      isUse(this.editForm.username).then((res) => {
        if (res.data == 1) {
          ForgetPassCode(this.editForm.username).then((res) => {
            if (res.code === 200) {
              this.time = 60;
              this.disabled = true;
              this.hintpromptstate = true;
              this.markedwords = "验证码发送成功";
              this.timeout = setTimeout(() => {
                this.hintpromptstate = false;
              }, 1000);
              // this.$message({
              //   message: "验证码发送成功",
              //   type: "success",
              //   center: true,
              // });
              this.timer();
            }
          });
        } else if (res.data == 0) {
          this.errorhint = true;
          this.errorhinttext = "账号不存在";
        }
      });
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s";
        this.timeouta = setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        let phoneInt = /^1[3456789]\d{9}$/;
        if (
          this.editForm.username != "" &&
          phoneInt.test(this.editForm.username) == true
        ) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
    },
    handleTab(){
      this.$emit('login')
    },
    close(){
      // this.$store.commit('loginState', false);
      this.registerClick();
    }
  },
  mounted() {},
  destroyed() {},
  created() {
  },
  updated() {},
  beforeDestroy(){
    clearTimeout(this.timeout);
    clearTimeout(this.timeouta);
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped >
@import './index.styl';
</style>



// WEBPACK FOOTER //
// src/components/wx-forgetpassword/index.vue